export function generateTimestamp(): string {
  return new Date().getTime().toString();
}

export const createServerDate = (date: string): string => {
  const dateType = new Date(date);
  return `${dateType.getDate()}-${dateType.getMonth() +
    1}-${dateType.getFullYear()}`;
};

export const createHtmlInputDate = (date: Date): string => {
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();
  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }
  return [year, month, day].join('-');
};

export const generateFutureDate = (
  days: number,
  months: number,
  years: number
): Date => {
  let todaysDate = new Date();
  if(months != 0){
    todaysDate.setMonth(todaysDate.getMonth()+months)
  } 
  if(days != 0) {
    todaysDate.setDate(todaysDate.getDate()+days)
  } 
  if(years != 0){
    todaysDate.setFullYear(todaysDate.getFullYear()+years)
  }
  return todaysDate;
};

export const generatePastDate = (
  days: number,
  months: number,
  years: number
): Date => {
  let todaysDate = new Date();
  if(months != 0){
    todaysDate.setMonth(todaysDate.getMonth()-months)
  } 
  if(days != 0) {
    todaysDate.setDate(todaysDate.getDate()-days)
  } 
  if(years != 0){
    todaysDate.setFullYear(todaysDate.getFullYear()-years)
  }
  return todaysDate;
};

export const createDateFromServerDate = (date: string | undefined): Date => {
  if (date) {
    const dateArr = date.split('-');
    return new Date(+dateArr[2], +dateArr[1] - 1, +dateArr[0]);
  }
  return new Date();
};
